/** @jsx jsx */

import type { TextareaHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { jsx } from '@balance-web/core';
import { useFieldContext } from '@balance-web/field';
import { buildDataAttributes } from '@balance-web/core';
import type { WithDataAttributeProp } from '@balance-web/core';
import type { InputSizeType } from '@balance-web/text-input';
import { useInputStyles } from '@balance-web/text-input';

type NativeElementProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export type TextareaProps = WithDataAttributeProp<
  {
    size?: InputSizeType;
    onChange: NonNullable<NativeElementProps['onChange']>;
    value: NonNullable<NativeElementProps['value']>;
    rows?: number;
  } & Omit<NativeElementProps, 'onChange' | 'type' | 'size' | 'value'>
>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ size = 'medium', rows = 4, data, ...textareaProps }, ref) => {
    // @ts-ignore Santise invalid dom attributes
    if ('blur' in textareaProps && typeof textareaProps.blur === 'function') {
      delete textareaProps.blur;
    }

    const styles = useInputStyles({ size, shape: 'square' });
    const { invalid, ...a11yProps } = useFieldContext();

    const dataAttributes = buildDataAttributes(data);

    return (
      <textarea
        ref={ref}
        aria-invalid={invalid}
        css={styles}
        rows={rows}
        {...dataAttributes}
        {...a11yProps}
        {...textareaProps}
      />
    );
  }
);
